import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent } from '@/components/ui/card';

function FileCardSkeleton() {
  return (
    <Card className="relative flex flex-col h-full shadow-none bg-transparent border-0">
      <div className="flex flex-col h-full">
        <div className="relative">
          <Skeleton className="w-full aspect-video rounded-lg bg-white dark:bg-black" />
        </div>
        <CardContent className="flex-grow flex flex-col justify-start py-4 px-0 bg-transparent">
          <div className="flex items-start justify-between relative">
            <div className="flex items-start w-full overflow-hidden">
              <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
              <div className="ml-2 flex-grow overflow-hidden w-full min-h-[4.5rem]">
                <Skeleton className="w-[90%] h-4 mb-2" />
                <Skeleton className="w-[70%] h-4 mb-3" />
                <div className="pl-px">
                  <Skeleton className="w-[50%] h-3 mt-1" />
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </div>
    </Card>
  );
}

export default FileCardSkeleton;
